import React, { useEffect } from "react";
import PageSerch from "../SerchDocters/Components/PageSerch";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import HowItWorks from "../Home/Components/HowItWorks";
import TakeARightStepForYourLife from "./Components/TakeARightStepForYourLife";
import MeetOurTeam from "./Components/MeetOurTeam";
import Reviews from "./Components/Reviews";
import EmergingClients from "./Components/EmergingClients";

const AboutUs = () => {
    useEffect(() => {
        // Initialize sliders when component mounts
        const authorpicslider = document.querySelector('#dc-authorpicslider-773074');
        const feedbackslider = document.querySelector('#dc-feedbackslider-773074');

        if (authorpicslider && feedbackslider) {
            // Initialize sliders using jQuery
            window.jQuery(authorpicslider).slick({
                rtl: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: feedbackslider,
                dots: false,
                loop: false,
                arrows: false,
                centerMode: true,
                centerPadding: '0',
                focusOnSelect: true,
                swipe: true,
                speed: 500,
                easing: 'easeOutElastic'
            });

            window.jQuery(feedbackslider).slick({
                rtl: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                loop: false,
                fade: false,
                swipe: false,
                asNavFor: authorpicslider
            });

            window.jQuery(authorpicslider).on('click init', function (event, slick, direction) {
                window.jQuery('.slick-current.slick-active').next('.slick-slide').addClass('dc-next-slide');
                window.jQuery('.slick-current.slick-active').prev('.slick-slide').addClass('dc-prev-slide');
            });

            window.jQuery(authorpicslider).on('beforeChange', function (event, slick, direction) {
                window.jQuery('.slick-slide').removeClass('dc-next-slide');
                window.jQuery('.slick-slide').removeClass('dc-prev-slide');
            });
        }
    }, []);

    return (
        <div>
            <PageSerch />
            <DynamicBreadcrumbs />

            <div class="container">
                <img src="//css.meddylist.com//wp-includes/images/media/default.svg" alt="About Us" style={{ padding: '80px 0 100px 0' }}></img>
            </div>

            <TakeARightStepForYourLife />
            <HowItWorks />
            <MeetOurTeam />
            <Reviews />
            <EmergingClients />
        </div>
    );
};

export default AboutUs;
